import { createContext, useContext, useState, ReactNode } from 'react';

interface AuthErrorContextType {
  showAuthError: () => void;
  hideAuthError: () => void;
  isAuthErrorVisible: boolean;
}

const AuthErrorContext = createContext<AuthErrorContextType | undefined>(undefined);

export function AuthErrorProvider({ children }: { children: ReactNode }) {
  const [isAuthErrorVisible, setIsAuthErrorVisible] = useState(false);

  const showAuthError = () => {
    setIsAuthErrorVisible(true);
  };

  const hideAuthError = () => {
    setIsAuthErrorVisible(false);
  };

  return (
    <AuthErrorContext.Provider
      value={{
        showAuthError,
        hideAuthError,
        isAuthErrorVisible,
      }}
    >
      {children}
    </AuthErrorContext.Provider>
  );
}

export function useAuthError() {
  const context = useContext(AuthErrorContext);
  if (context === undefined) {
    throw new Error('useAuthError must be used within an AuthErrorProvider');
  }
  return context;
}

